<div class="contentradios" *ngIf='radios && radios.length > 0'>    
    <div class="boxradios">
        <div class="row filaradios m-0">
            <div class="col-12 col-md-6 col-lg-4 radio1content">
                <div class="boxradio1" [ngStyle]="{'background-image': 'url(' + radios[2].image + ')'}">
                    <div class="row radiotextprincipal m-0">
                        <div class="col-md-12 radiotext">
                            <p>{{radios[2].name}}</p>
                        </div>
                        <div class="col-md-12 radiocinta">
                            <div class="cinta"></div>
                        </div>
                        <div class="col-md-12 playlist">     
                            <button mat-button (click)="pauseAll()" *ngIf="(serviceRadio.RADIOFM961 && serviceRadio.PLAYLISTONOFF)" class="btnStyle">
                                <mat-icon class="btnPause">pause</mat-icon>
                            </button>
                            <button mat-button (click)="playRadioFM()" *ngIf="!(serviceRadio.RADIOFM961 && serviceRadio.PLAYLISTONOFF)" class="btnStyle">
                                <mat-icon class="btnPlay" aria-hidden="false" aria-label="Example pause icon" >play_arrow</mat-icon>
                            </button>                     
                            <button mat-button [matMenuTriggerFor]="menu1" class="btnStyle">
                                <mat-icon class="btnVolumen" aria-hidden="false" aria-label="Example volume_up icon">volume_up</mat-icon>
                            </button>
                                <mat-menu  #menu1="matMenu">
                                    <mat-slider  vertical='false' 
                                    #mySlidercenFM
                                    [(ngModel)]="valuecenFM"
                                    (slideend)="sliderOnChangeCenFM(mySlidercenFM.value)" 
                                    (pointerup)="sliderOnChangeCenFM(mySlidercenFM.value)">
                                    </mat-slider>                    
                                </mat-menu>              
                        </div>
                    </div>
                    
                </div>

            </div>
            <div class="col-12 col-md-6 col-lg-4 radio1content">
                <div class="boxradio1" [ngStyle]="{'background-image': 'url(' + radios[0].image + ')'}">
                    <div class="row radiotextprincipal m-0">
                        <div class="col-md-12 radiotext">
                            <p>{{radios[0].name}}</p>
                        </div>
                        <div class="col-md-12 radiocinta">
                            <div class="cinta"></div>
                        </div>
                        <div class="col-md-12 playlist">
                           
                            <button mat-button mat-button (click)="pauseAll()" *ngIf="(serviceRadio.RADIOUNIVERSAL && serviceRadio.PLAYLISTONOFF)" class="btnStyle">
                                <mat-icon class="btnPause" aria-hidden="false" aria-label="Example pause icon">pause</mat-icon>
                            </button>
                              
                            <button mat-button mat-button (click)="playRadioUniversal()" *ngIf="!(serviceRadio.RADIOUNIVERSAL && serviceRadio.PLAYLISTONOFF)" class="btnStyle">
                                <mat-icon class="btnPlay" aria-hidden="false" aria-label="Example pause icon">play_arrow</mat-icon>
                            </button>        
                            
                            <button mat-button [matMenuTriggerFor]="menu2" class="btnStyle">
                                <mat-icon class="btnVolumen" aria-hidden="false" aria-label="Example volume_up icon">volume_up</mat-icon>
                            </button>
                                <mat-menu  #menu2="matMenu">
                                    <mat-slider  vertical='false' 
                                    #mySlideruniFM
                                    [(ngModel)]="valueuniFM"
                                    (slideend)="sliderOnChangeUniFM(mySlideruniFM.value)" 
                                    (pointerup)="sliderOnChangeUniFM(mySlideruniFM.value)"></mat-slider>                    
                                </mat-menu>              
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="col-12 col-md-8 col-lg-4 radio1content">
                <div class="boxradio1" [ngStyle]="{'background-image': 'url(' + radios[1].image + ')'}">
                    <div class="row radiotextprincipal m-0">
                        <div class="col-md-12 radiotext">
                            <p>{{radios[1].name}}</p>
                        </div>
                        <div class="col-md-12 radiocinta">
                            <div class="cinta"></div>
                        </div>
                        <div class="col-md-12 playlist">
                  
                            <button mat-button (click)="pauseAll()" *ngIf="(serviceRadio.RADIOAM247 && serviceRadio.PLAYLISTONOFF)" class="btnStyle">
                                <mat-icon class="btnPause" aria-hidden="false" aria-label="Example pause icon">pause</mat-icon>
                            </button>

                            <button mat-button (click)="playRadioAM()" *ngIf="!(serviceRadio.RADIOAM247 && serviceRadio.PLAYLISTONOFF)" class="btnStyle">
                                <mat-icon class="btnPlay" aria-hidden="false" aria-label="Example pause icon">play_arrow</mat-icon>
                            </button>        

                            <button mat-button [matMenuTriggerFor]="menu3" class="btnStyle">
                                <mat-icon class="btnVolumen" aria-hidden="false" aria-label="Example volume_up icon">volume_up</mat-icon>
                            </button>
                                <mat-menu  #menu3="matMenu">
                                    <mat-slider  vertical='false' 
                                    #mySlidercenAM
                                    [(ngModel)]="valuecenAM"
                                    (slideend)="sliderOnChangeCenAM(mySlidercenAM.value)" 
                                    (pointerup)="sliderOnChangeCenAM(mySlidercenAM.value)"></mat-slider>                    
                                </mat-menu>              
                        </div>
                    </div>
                    
                </div>

            </div>
        </div>        
        
        <div class="carousel">
            <app-slider>
                <div class="boxradio1" appSliderItem [ngStyle]="{'background-image': 'url(' + radios[2].image + ')'}">
                    <div class="row radiotextprincipal m-0">
                        <div class="col-md-12 radiotext">
                            <p>{{radios[2].name}}</p>
                        </div>
                        <div class="col-md-12 radiocinta">
                            <div class="cinta"></div>
                        </div>
                        <div class="col-md-12 playlist">
                           
                            <button mat-button (click)="pauseAll()" *ngIf="(serviceRadio.RADIOFM961 && serviceRadio.PLAYLISTONOFF)" class="btnStyle">
                                <mat-icon class="btnPause">pause</mat-icon>
                            </button>
                              
            
                            <button mat-button (click)="playRadioFM()" *ngIf="!(serviceRadio.RADIOFM961 && serviceRadio.PLAYLISTONOFF)" class="btnStyle">
                                <mat-icon class="btnPlay" aria-hidden="false" aria-label="Example pause icon" >play_arrow</mat-icon>
                            </button>        
                            
                      
                            <button mat-button [matMenuTriggerFor]="menu1" class="btnStyle">
                                <mat-icon class="btnVolumen" aria-hidden="false" aria-label="Example volume_up icon">volume_up</mat-icon>
                            </button>
                                <mat-menu  #menu1="matMenu">
                                    <mat-slider  vertical='false' 
                                    #mySlidercenFM
                                    [(ngModel)]="valuecenFM"
                                    (slideend)="sliderOnChangeCenFM(mySlidercenFM.value)" 
                                    (pointerup)="sliderOnChangeCenFM(mySlidercenFM.value)">
                                    </mat-slider>                    
                                </mat-menu>              
                        </div>
                    </div>
                </div>

                <div class="boxradio1" appSliderItem [ngStyle]="{'background-image': 'url(' + radios[0].image + ')'}">
                    <div class="row radiotextprincipal m-0">
                        <div class="col-md-12 radiotext">
                            <p>{{radios[0].name}}</p>
                        </div>
                        <div class="col-md-12 radiocinta">
                            <div class="cinta"></div>
                        </div>
                        <div class="col-md-12 playlist">

                            <button mat-button mat-button (click)="pauseAll()" *ngIf="(serviceRadio.RADIOUNIVERSAL && serviceRadio.PLAYLISTONOFF)" class="btnStyle">
                                <mat-icon class="btnPause" aria-hidden="false" aria-label="Example pause icon">pause</mat-icon>
                            </button>

                            <button mat-button mat-button (click)="playRadioUniversal()" *ngIf="!(serviceRadio.RADIOUNIVERSAL && serviceRadio.PLAYLISTONOFF)" class="btnStyle">
                                <mat-icon class="btnPlay" aria-hidden="false" aria-label="Example pause icon">play_arrow</mat-icon>
                            </button>        

                            <button mat-button [matMenuTriggerFor]="menu2" class="btnStyle">
                                <mat-icon class="btnVolumen" aria-hidden="false" aria-label="Example volume_up icon">volume_up</mat-icon>
                            </button>
                                <mat-menu  #menu2="matMenu">
                                    <mat-slider  vertical='false' 
                                    #mySlideruniFM
                                    [(ngModel)]="valueuniFM"
                                    (slideend)="sliderOnChangeUniFM(mySlideruniFM.value)" 
                                    (pointerup)="sliderOnChangeUniFM(mySlideruniFM.value)"></mat-slider>                    
                                </mat-menu>              
                        </div>
                    </div>
                </div>

                <div class="boxradio1" appSliderItem [ngStyle]="{'background-image': 'url(' + radios[1].image + ')'}">
                    <div class="row radiotextprincipal m-0">
                        <div class="col-md-12 radiotext">
                            <p>{{radios[1].name}}</p>
                        </div>
                        <div class="col-md-12 radiocinta">
                            <div class="cinta"></div>
                        </div>
                        <div class="col-md-12 playlist">
                            <button mat-button (click)="pauseAll()" *ngIf="(serviceRadio.RADIOAM247 && serviceRadio.PLAYLISTONOFF)" class="btnStyle">
                                <mat-icon class="btnPause" aria-hidden="false" aria-label="Example pause icon">pause</mat-icon>
                            </button>
                            <button mat-button (click)="playRadioAM()" *ngIf="!(serviceRadio.RADIOAM247 && serviceRadio.PLAYLISTONOFF)" class="btnStyle">
                                <mat-icon class="btnPlay" aria-hidden="false" aria-label="Example pause icon">play_arrow</mat-icon>
                            </button>        
                            <button mat-button [matMenuTriggerFor]="menu3" class="btnStyle">
                                <mat-icon class="btnVolumen" aria-hidden="false" aria-label="Example volume_up icon">volume_up</mat-icon>
                            </button>
                                <mat-menu  #menu3="matMenu">
                                    <mat-slider  vertical='false' 
                                    #mySlidercenAM
                                    [(ngModel)]="valuecenAM"
                                    (slideend)="sliderOnChangeCenAM(mySlidercenAM.value)" 
                                    (pointerup)="sliderOnChangeCenAM(mySlidercenAM.value)"></mat-slider>                    
                                </mat-menu>              
                        </div>
                    </div>
                </div>
            </app-slider>
        </div>
    
    </div>
</div>
